import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants";


const OPTIONS = [
	{label: 'Country', value: GROUPED_BY.COUNTRY},
	{label: 'Retailer', value: GROUPED_BY.RETAILER},
	{label: 'Company', value: GROUPED_BY.COMPANY},
	{label: 'Brand', value: GROUPED_BY.BRAND}
]

export default function BannerPercentageSplitBySelect({ value, onChange, excludeOptions=[] }) {
	return <SelectSeeker
		sx={{ minWidth: 150 }}
		options={OPTIONS}
		label="Split By"
		value={value}
		onChange={e => onChange(e.target.value)}
		excludeOptions={excludeOptions}
	/>

}